import { z } from "zod"

export enum LegalDocumentType {
  TERMS_OF_SERVICE = "TERMS_OF_SERVICE",
  PRIVACY_POLICY = "PRIVACY_POLICY",
}

export const LegalDocumentSchema = z.object({
  id: z.guid(),
  link: z.string().url(),
  type: z.nativeEnum(LegalDocumentType),
  storeId: z.guid(),
})

export const CreateLegalDocumentSchema = LegalDocumentSchema.omit({
  id: true,
})

export type LegalDocument = z.infer<typeof LegalDocumentSchema>
export type CreateLegalDocument = z.infer<typeof CreateLegalDocumentSchema>
